<script setup lang="ts">
import CoreButton from "@/components/common/CoreButton/CoreButton.vue";
import { config } from "@/config/envConfig";
import siaTimeline from "@theme/branding/timeline.png";
import { onMounted } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

onMounted(() => {
  const navConfig = { title: t("supgrade.previewTitle") };
  window.NavatticEmbed?.initPopup(config.NAVATTIC_URL, navConfig);
});
const openDemo = () => {
  window.NavatticEmbed.openPopup(config.NAVATTIC_URL);
};
</script>
<template>
  <div class="image-container">
    <img
      :src="siaTimeline"
      alt=""
    />
    <div class="overlay">
      <CoreButton
        class="overlay-btn"
        type="default"
        @click="openDemo"
        >{{ $t("supgrade.previewButton") }}</CoreButton
      >
    </div>
  </div>
</template>
<style scoped>
.image-container {
  position: relative;
  display: inline-block;
  align-self: flex-start;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
}
.overlay-btn {
  border-width: 2px;
  border-color: #1bbae1;
  color: #1bbae1;
}
</style>
